import { Media, MediaFolder, MediaType, SubjectType } from '@atom/types/media';

export enum ModalType {
  NONE = 'NONE',
  CREATE_FOLDER = 'CREATE_FOLDER',
  EDIT_FOLDER = 'EDIT_FOLDER',
  DELETE_FOLDER = 'DELETE_FOLDER',
  BULK_DELETE = 'BULK_DELETE',
  MOVE_MEDIA = 'MOVE_MEDIA',
}

export enum RowModalType {
  NONE = 'NONE',
  EDIT_FOLDER = 'EDIT_FOLDER',
  CREATE_SUB_FOLDER = 'CREATE_SUB_FOLDER',
  MOVE_FOLDER = 'MOVE_FOLDER',
  DELETE_FOLDER = 'DELETE_FOLDER',
  EDIT_FILE = 'EDIT_FILE',
  DELETE_FILE = 'DELETE_FILE',
}

export enum FolderModalType {
  NONE = 'NONE',
  EDIT = 'EDIT',
  CREATE_SUB = 'CREATE_SUB',
  MOVE = 'MOVE',
  DELETE = 'DELETE',
}

export type MediaRow = (Media | MediaFolder) & {
  fileId?: string;
  type?: MediaType;
  fileExtension?: string;
  ancestors?: string[];
};

export type FilesData = {
  files: FileList;
  widths?: number[];
};

export type Breadcrumb = { id: string; name: string };

export type MediaSortColumn =
  | 'name'
  | 'fileExtension'
  | 'createdBy'
  | 'createdDate';

export type SortDirection = 'asc' | 'desc';

export type PendingEdit =
  | { kind: 'create'; parentFolderId: string; tempId: string; name: string }
  | { kind: 'rename'; id: string; name: string };

export type FolderTreeOpenModal =
  | { type: FolderModalType.NONE }
  | { type: FolderModalType.EDIT; id: string; name: string }
  | { type: FolderModalType.CREATE_SUB; id: string }
  | { type: FolderModalType.MOVE; id: string; ancestors: string[] }
  | { type: FolderModalType.DELETE; id: string; name: string };

export type UseFilesTabDataArgs = {
  subjectId: string;
  subjectType: SubjectType;
  folderId: string;
  mediaType: MediaType | null;
  searchName: string;
};
